// Zlatá lamí silueta — znak Lama Klubu (rub karet, vstupní tlačítko).
// Zjednodušený port SVG generátoru ze schváleného prototypu.

export function LamaMark({ size = 38 }: { size?: number }) {
  const body = "#E3B15C", shade = "#C7913B", snout = "#F3D9A4", dark = "#141C31";
  return (
    <svg viewBox="0 0 120 120" style={{ width: size, height: size }} aria-hidden="true">
      <ellipse cx="60" cy="112" rx="34" ry="5" fill="rgba(0,0,0,.25)" />
      <rect x="52" y="88" width="9" height="24" rx="4.5" fill={body} />
      <rect x="88" y="88" width="9" height="24" rx="4.5" fill={body} />
      <rect x="64" y="90" width="9" height="22" rx="4.5" fill={shade} />
      <rect x="76" y="90" width="9" height="22" rx="4.5" fill={shade} />
      <ellipse cx="74" cy="74" rx="32" ry="24" fill={body} />
      <circle cx="103" cy="66" r="7" fill={body} />
      <rect x="38" y="26" width="20" height="44" rx="10" fill={body} />
      <path d="M34 16 q-2 -12 6 -10 q3 6 -1 11 z" fill={body} />
      <path d="M46 16 q2 -12 10 -9 q2 6 -3 10 z" fill={body} />
      <ellipse cx="41" cy="28" rx="15" ry="12" fill={body} />
      <ellipse cx="29" cy="32" rx="8" ry="6.2" fill={snout} />
      <circle cx="45" cy="26" r="2.4" fill={dark} />
      <circle cx="47" cy="25" r=".8" fill="#fff" />
      <path d="M34 37 q3 2.5 6 0" stroke={dark} strokeWidth="1.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}
